<script lang="ts">
import { onMount } from "svelte";

import { modifiers } from "../store";

export let index: number;
export let key: string;
export let options: any;

let hasOptions = false;

onMount(async ( ) => {
	if (options.then) {
		options = await options;
	}
	hasOptions = true;
});

</script>
<div class="form-group mb-3">
	<label for={`Modifiers${index}.${key}`} class="text-capitalize">{key}</label>
{#if hasOptions}
	<select class="form-select" id={`Modifiers${index}.${key}`} bind:value={$modifiers[index][key]}>
		<option value="">Select</option>
		{#each options as value}
			{#if value}
				<option>{value}</option>
			{/if}
		{/each}
	</select>
{:else}
	<span class="form-text">Loading data...</span>
{/if}
</div>
